<template>
  <div class="page-banner" :style="{ backgroundImage: `url(${bgImage})` }">
    <div class="page-banner-overlay"></div>
    <div class="page-banner-body">
      <div class="page-banner-tag" data-aos="fade-down" data-aos-duration="600">{{ tag }}</div>
      <h1 class="page-banner-title" data-aos="fade-up" data-aos-duration="700">{{ title }}</h1>
      <p class="page-banner-sub" v-if="subtitle" data-aos="fade-up" data-aos-delay="100" data-aos-duration="700">{{ subtitle }}</p>
      <nav class="page-breadcrumb" data-aos="fade-up" data-aos-delay="180" data-aos-duration="700">
        <router-link to="/home" class="bc-link">首页</router-link>
        <i class="fas fa-chevron-right bc-sep"></i>
        <span class="bc-current">{{ title }}</span>
      </nav>
    </div>
    <!-- 底部波浪装饰 -->
    <div class="page-banner-wave">
      <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,30 C360,60 1080,0 1440,30 L1440,60 L0,60 Z" fill="#f8f9fa"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBanner',
  props: {
    title:    { type: String, default: '页面标题' },
    subtitle: { type: String, default: '' },
    tag:      { type: String, default: 'PAGE' },
    bgImage:  { type: String, default: require('@/assets/img/banner_1.jpg') }
  }
}
</script>

<style scoped>
.page-banner {
  position: relative;
  height: 340px;
  margin-top: 70px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 双层遮罩：底部渐深，整体偏蓝 */
.page-banner-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(to bottom, rgba(0,20,60,0.55) 0%, rgba(0,10,40,0.75) 100%);
}

/* 内容 */
.page-banner-body {
  position: relative;
  z-index: 1;
  text-align: center;
  color: #fff;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

/* 小标签 */
.page-banner-tag {
  display: inline-block;
  padding: 4px 16px;
  border: 1px solid rgba(255,255,255,0.4);
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: rgba(255,255,255,0.8);
  text-transform: uppercase;
}

/* 主标题 */
.page-banner-title {
  font-size: clamp(28px, 4vw, 46px);
  font-weight: 800;
  margin: 0;
  line-height: 1.2;
  letter-spacing: 1px;
  text-shadow: 0 2px 12px rgba(0,0,0,0.25);
}

/* 副标题 */
.page-banner-sub {
  font-size: 15px;
  color: rgba(255,255,255,0.78);
  margin: 0;
  font-weight: 300;
  letter-spacing: 0.5px;
}

/* 面包屑 */
.page-breadcrumb {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 20px;
  background: rgba(255,255,255,0.12);
  backdrop-filter: blur(6px);
  border-radius: 30px;
  border: 1px solid rgba(255,255,255,0.18);
  font-size: 13px;
  margin-top: 4px;
}
.bc-link {
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  transition: color 0.2s;
}
.bc-link:hover { color: #fff; }
.bc-sep {
  font-size: 9px;
  color: rgba(255,255,255,0.4);
}
.bc-current {
  color: #fff;
  font-weight: 600;
}

/* 底部波浪 */
.page-banner-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 2;
}
.page-banner-wave svg {
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .page-banner { height: 240px; margin-top: 56px; }
  .page-banner-title { font-size: 26px; }
  .page-banner-sub { font-size: 13px; }
  .page-banner-wave { height: 36px; }
}
</style>



// WEBPACK FOOTER //
// src/components/PageBanner.vue